import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import QCXFinalPercentualField from '../../shared-components/final-percentual-field/QCXFinalPercentualField';

export default function QCXFinalPercentualFieldRender({
  disabled,
  name,
  ...restProps
}) {
  const [key, setKey] = useState(name);

  useEffect(() => {
    if (disabled) {
      setKey(`${name.replaceAll('.', '-')}-${uuid()}`);
    }
  }, [
    name,
    disabled
  ]);

  return (
    <>
      <QCXFinalPercentualField
        key={key}
        name={name}
        disabled={disabled}
        {...restProps}
      />
    </>
  );
}
